import axios from 'axios';

export function getRecaptchaSiteKey() {
    return axios.get('/api/recaptcha/key', {
        params: {
            RECAPTCHA_SCORE_THRESHOLD: window.localStorage.getItem('RECAPTCHA_SCORE_THRESHOLD') || undefined
        }
    });
}

export function verifyReCaptcha(token) {
    return axios.post('/api/recaptcha/verify', {
        token
    });
}
